import { render, staticRenderFns } from "./BeCardListService.vue?vue&type=template&id=1f68c8c3&scoped=true"
import script from "./BeCardListService.vue?vue&type=script&lang=js"
export * from "./BeCardListService.vue?vue&type=script&lang=js"
import style0 from "./BeCardListService.vue?vue&type=style&index=0&id=1f68c8c3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f68c8c3",
  null
  
)

export default component.exports